import type { PropsWithChildren } from 'react';

import { VBasePopoverContextProvider } from './VBasePopoverContextProvider';
import { VBaseInnerPopover } from './VInnerBasePopover';
import type { VBasePopoverProps } from './type';

export const VBasePopover = ({
  children,
  ref,
  ...rest
}: PropsWithChildren<VBasePopoverProps> &
  React.RefAttributes<HTMLDivElement>) => {
  return (
    <VBasePopoverContextProvider {...rest}>
      <VBaseInnerPopover ref={ref}>{children}</VBaseInnerPopover>
    </VBasePopoverContextProvider>
  );
};

VBasePopover.displayName = 'VBasePopover';
